<template>
  <div
    id="schedules-select-container"
    class="selections schedules-select-container"
  >
    <AppDropdown
      class="schedules-view-by"
      direction="left"
      trigger-classes="btn btn-naked"
    >
      <template #trigger>
        <div
          class="d-flex align-items-center dropdown-toggle btn px-5"
          data-toggle="dropdown"
        >
          <i
            class="hi text-muted"
            :class="`hi-${icon}`"
          ></i>
          <p class="text-lighter mb-0 ml-5">
            {{ label }}: <span class="text-blue">{{ selected.text }}</span>
          </p>
          <i class="hi hi-caret hi-10 text-lighter ml-5"></i>
        </div>
      </template>

      <AppDropdownItem
        v-for="option in options"
        :key="option.id"
        :data-value="option.id"
        @click="selected = option.id"
      >
        {{ option.text }}
      </AppDropdownItem>
    </AppDropdown>
  </div>
</template>

<script>
import { mapInertiaProps } from '~/utils/inertia';

export default {
  name: 'SchedulesDropdown',
  props: {
    label: {
      type: String,
      default: 'View by',
    },
    icon: {
      type: String,
      default: 'group-by',
    },
    options: {
      type: Array,
      default: () => [],
    },
    initialValue: {
      type: String,
      default: 'time',
    },
    paramName: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    selection: null,
  }),
  computed: {
    ...mapInertiaProps({
      currentUserRole: 'current_user_role',
      organizationId: ({ organization }) => organization.id,
    }),
    selected: {
      get() {
        return this.options.find((option) => option.id === this.selection || option.id === this.initialValue);
      },
      set(selectedValue) {
        window.analytics?.track('Calendar table view by changed', {
          organization_id: this.organizationId,
          user_role: this.currentUserRole,
          current_page_title: document.title,
          current_url: document.url,
          preset_used: this.selected.id,
          preset_value: selectedValue,
        });
        this.selection = selectedValue;
        this.filterChange([{ key: this.paramName, value: selectedValue }], { preserveScroll: true });
      },
    },
  },
  methods: {
    filterChange(newFilterValue, options = {}) {
      this.$emit('filter-change', newFilterValue, options);
    },
  },
};
</script>
